import React, {useState} from 'react';
import IconButton from "@material-ui/core/IconButton";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {transitionToProfile} from "../../modules/Transition/actions";
import {useDispatch, useSelector} from "react-redux";

const ProfileButton = () => {
    // Get the current state from Store
    const userState = useSelector(state => state.user);
    const isLoggedIn = userState.isLoggedIn;

    const dispatch = useDispatch();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
            >
                <AccountCircleIcon />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
            >
                {isLoggedIn && (
                    <MenuItem onClick={() => {
                        handleClose();
                        dispatch(transitionToProfile())
                    }}>プロフィール</MenuItem>
                )}
            </Menu>
        </>
    );
};

export default ProfileButton;